import styled from 'styled-components'

const PageWrapper = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  position: relative;
`

export default PageWrapper
